import React from 'react';
import { Form, Field } from 'react-final-form';

import { checkEmail } from '../../helpers';
import { renderPlaceholderTextField } from './fields';
import { connect } from 'react-redux';
import { getMessage as t } from '../../utils/utils';
import { messagesSelector } from '../../helpers/selectors';
import { FormattedMessage } from 'react-intl';

const validate = (values, props) => {
  const errors = {};

  const emailError = checkEmail(values.email, props.m);

  if (emailError) errors.email = emailError;

  return errors;
};

const ExternalLoginForm = (props) => {
  const { onSubmit, externalLoginError, externalLoginFetching, m } = props;

  return (
    <div className="external-login-main">
      <div className="external-login-desc">
        <FormattedMessage id="sso.login.description" />
      </div>
      <Form onSubmit={onSubmit} validate={(values) => validate(values, props)}>
        {({ handleSubmit }) => (
          <form
            className="form-content external-login-form"
            onSubmit={handleSubmit}
            noValidate
          >
            <Field
              onFocus={props.onFocus}
              name="email"
              component={renderPlaceholderTextField}
              placeholder={t(m, 'generic.email')}
              type="email"
            />
            <div className="text-center">
              <button
                type="submit"
                disabled={!!externalLoginFetching}
                className="btn btn-accent primary-btn btn-md mt-40"
              >
                {t(m, 'label.continue')}
              </button>
            </div>
            {externalLoginError && (
              <div className="text-danger text-center mt-25">{externalLoginError}</div>
            )}
          </form>
        )}
      </Form>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    m: messagesSelector(state),
    externalLoginError: state.user.externalLoginError,
    externalLoginFetching: state.user.externalLoginFetching
  };
};


export default connect(mapStateToProps)(ExternalLoginForm);
